import { __assign, __decorate, __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { MenuItem } from '@skbkontur/react-ui/components/MenuItem';
import { CommonWrapper } from '@skbkontur/react-ui/internal/CommonWrapper';
import { TopBarLocaleHelper } from './locale';
import { TopBarDropdown } from './TopBarDropdown';
/**
 * Меню работы с кабинетом пользователя
 *
 * @visibleName TopBar.User
 */
var TopBarUser = /** @class */ (function (_super) {
    __extends(TopBarUser, _super);
    function TopBarUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopBarUser.prototype.render = function () {
        var _a = this.props, userName = _a.userName, cabinetUrl = _a.cabinetUrl;
        var _b = this.locale, cabinetSettings = _b.cabinetSettings, cabinetCertificates = _b.cabinetCertificates, cabinetServices = _b.cabinetServices;
        return (React.createElement(CommonWrapper, __assign({}, this.props),
            React.createElement(TopBarDropdown, { icon: "user", label: userName },
                React.createElement(MenuItem, { href: cabinetUrl, target: "_blank" }, cabinetSettings),
                React.createElement(MenuItem, { href: cabinetUrl + "/certificates", target: "_blank" }, cabinetCertificates),
                React.createElement(MenuItem, { href: cabinetUrl + "/services", target: "_blank" }, cabinetServices))));
    };
    TopBarUser.__KONTUR_REACT_UI__ = 'TopBarUser';
    TopBarUser.defaultProps = {
        cabinetUrl: 'https://cabinet.kontur.ru',
    };
    TopBarUser.propTypes = {
        userName: PropTypes.string,
        /**
         * URL для кастомизации ссылок в меню пользователя
         */
        cabinetUrl: PropTypes.string,
    };
    TopBarUser = __decorate([
        locale('TopBar', TopBarLocaleHelper)
    ], TopBarUser);
    return TopBarUser;
}(React.Component));
export { TopBarUser };
